module.exports = __webpack_public_path__ + "static/cosi2-d4b81a6df0ee9d6331fb7d2caff4110f.jpg";